import styled from 'styled-components';
import { caption, colors, fontSizes, fontWeights, spacing } from 'ui/theme';

export const ControlBadgeStyle = styled.div`
  ${caption}
  background-color: ${colors.grey5};
  border-radius: ${spacing.quarter};
  color: ${colors.textSecondary};
  padding-left: ${spacing.half};
  padding-right: ${spacing.half};
`;

export const TrophyWrapper = styled.div`
  align-items: center;
  display: flex;
  font-size: ${fontSizes.s12};
  font-weight: ${fontWeights.medium};
  gap: ${spacing.quarter};
`;

export const WinnerBadgeStyle = styled(TrophyWrapper)`
  color: ${colors.success100};
`;

export const WinningBadgeStyle = styled(TrophyWrapper)`
  padding: ${spacing.eighth} ${spacing.quarter};
  border-radius: ${spacing.quarter};
  background-color: ${colors.cyan10};
  color: ${colors.cyan100};
`;
